import React from 'react';
import { Field } from '~/components/Formik';

interface ActionCheckboxProps {
    checkBoxId: string;
    readOnly: boolean;
}
export function ActionCheckbox({ checkBoxId, readOnly }: ActionCheckboxProps) {
    return (
        <Field
            type="checkbox"
            id={checkBoxId}
            name={checkBoxId}
            className="form-check-input form-check-inline"
            disabled={readOnly}
        />
    );
}
